import { render, staticRenderFns } from "./Democompras.vue?vue&type=template&id=2cb963e1&"
import script from "./Democompras.vue?vue&type=script&lang=js&"
export * from "./Democompras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports